<template>
  <div class="tournament-ended-label">
    <div class="tournament-timer">
      <p class="tournament-timer__ended-text">
        <span>
          <i class="fa-regular fa-clock"></i>{{ endedTimerText }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TournamentEndedLabel',
  props: {
    tournamentEndDate: {
      type: Date,
      required: true
    }
  },
  computed: {
    formattedEndDate() {
      if (!this.tournamentEndDate) return '';
      const options = { month: 'short', day: 'numeric', year: 'numeric' };
      return new Date(this.tournamentEndDate).toLocaleDateString(this.$i18n.locale, options);
    },
    endedTimerText() {
      if (!this.formattedEndDate) return this.$t('tournamentEnded');
      return `${this.$t('tournamentEnded')} ${this.formattedEndDate}`;
    }
  }
};
</script>

<style lang="scss">
$swt-light-gray: #EEEEEE;
$swt-dark-gray: #303740;

.tournament-ended-label {
  width: 100%;

  .tournament-timer {
    display: flex;
    font-family: 'Avenir', sans-serif;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    padding: 5px 12px;
    background: $swt-light-gray;
    border-radius: 6px;
    width: 100%;
    justify-content: flex-start;

    i {
      margin-right: 10px;
    }
  }

  .tournament-timer__ended-text {
    width: auto;
    margin: 0;
    text-align: left;
  }
}

.theme--dark {
  .tournament-ended-label .tournament-timer {
    background-color: $swt-dark-gray;
  }
}
</style>
